import {t} from 'app/translations';

/** Number of bull columns written to the CSV export. */
export const lineBullCount = 5;
/** Column separator used by the CSV export. */
export const csvColumnSeparator = ';';
/** Newline sequence used by the CSV export. */
export const csvNewLine = '\n';

/**
 * Builds the CSV header used by mating export files.
 *
 * @returns The normalized CSV header row.
 */
export const buildCsvHeader = (): string => {
    const tm = t('mating');
    const headerStringArray: Array<string> = [tm('earTagShort')];

    for (let i = 0; i < lineBullCount; i++) {
        headerStringArray.push(
            `${tm('lineRegistry')} (${i + 1})`,
            `${tm('name')} (${i + 1})`,
            `${tm('score')} (${i + 1})`,
            `${tm('bullInbreeding')} (${i + 1})`,
        );
    }

    return headerStringArray
        .join(csvColumnSeparator)
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '');
};
